import React from 'react';

const SvgLy = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LY_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="LY_svg__d" d="M0 6.667h28v6.667H0z" />
      <filter
        x="-5.4%"
        y="-22.5%"
        width="110.7%"
        height="145%"
        filterUnits="objectBoundingBox"
        id="LY_svg__c"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
      <path id="LY_svg__f" d="M0 13.333h28V20H0z" />
      <filter
        x="-5.4%"
        y="-22.5%"
        width="110.7%"
        height="145%"
        filterUnits="objectBoundingBox"
        id="LY_svg__e"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LY_svg__b" fill="#fff">
        <use xlinkHref="#LY_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#LY_svg__a" />
      <g mask="url(#LY_svg__b)">
        <use fill="#000" filter="url(#LY_svg__c)" xlinkHref="#LY_svg__d" />
        <use fill="#262626" xlinkHref="#LY_svg__d" />
      </g>
      <g mask="url(#LY_svg__b)">
        <use fill="#000" filter="url(#LY_svg__e)" xlinkHref="#LY_svg__f" />
        <use fill="#34B857" xlinkHref="#LY_svg__f" />
      </g>
      <path fill="#F41F34" mask="url(#LY_svg__b)" d="M0 0h28v6.667H0z" />
      <path
        d="M15.111 8.337a1.667 1.667 0 1 0 0 3.326 2 2 0 1 1 0-3.326zm.222 2.33a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334z"
        fill="#FFF"
        mask="url(#LY_svg__b)"
      />
    </g>
  </svg>
);

export default SvgLy;
